import './i18next';
import '@justgiving/carepack-typography';
import '@justgiving/carepack-core';
import '@justgiving/carepack-chips/chips.css';
import '@justgiving/carepack-dialog/dialog.css';

import { browserTracingIntegration, init } from '@sentry/react';

import App from './components/App/App';
import { BrowserRouter } from 'react-router-dom';
import config from './config';
import { createRoot } from 'react-dom/client';

init({
  dsn: config.sentryDsn,
  replaysOnErrorSampleRate: 0.5,
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 0.1,
  environment: config.env,
  allowUrls: [/justgiving\.com/, /jg-cdn\.com/],
  ignoreErrors: [
    /CookieConsent/,
    'Load failed',
    /twttr/,
    /Error: refreshAccessToken response not ok: 422, Unprocessable Entity/, // createAuth error when service responds incorrectly
    /timed out after 10000ms/, // ES problem with service timeouts
    /Failed to execute 'importScripts' on 'WorkerGlobalScope'/, // HEAP issue where script does not load
    /Cannot read properties of undefined \(reading 'domInteractive'\)/, // in-app WebView browsers missing performance timing API
    'Failed to fetch',
    /^ResizeObserver/,
    /TypeError: Load failed/,
    /TypeError: The network connection was lost./,
    /TypeError: NetworkError when attempting to fetch resource/,
    /TypeError: The request timed out/,
    /TypeError: cancelled/,
    /TypeError: The network connection was lost/,
    'TypeError: Network request failed',
    'bb',
  ],
});

const loadSentryReplay = () =>
  import(/* webpackChunkName: "sentry-replay" */ './sentry/replay')
    .then(({ addReplay }) => addReplay())
    .catch(() => {
      // Replay is best-effort; ignore load failures so we don't break the app.
    });

if (typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(loadSentryReplay, { timeout: 5000 });
} else {
  setTimeout(loadSentryReplay, 2000);
}

createRoot(document.getElementById('app')!).render(
  <BrowserRouter basename={config.pathPrefix}>
    <App />
  </BrowserRouter>
);
